import React from 'react';
import Box from '@mui/material/Box';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { Content } from './components';

const News = () => {
    return (
        <Main>
            <Box>
                <Container>
                    <Content />
                </Container>
            </Box>
        </Main>
    );
};

export default News;
